import { useEffect, useState } from 'react';
import { Modal } from 'react-daisyui';
import SectionStep from 'components/Appointment/ConfirmAppointmentModal/SectionStep';

const ProfileModal = ({ stepId, data, practice, completed, onClose }) => {
  const [saved, setSaved] = useState(null);

  useEffect(() => {
    setSaved(null);
  }, [stepId]);

  return (
    <Modal
      open={Boolean(stepId)}
      onClose={onClose}
      style={{ margin: 0 }}
      backdrop
      className="relative flex max-h-[calc(100dvh-1.5rem)] w-[92%] max-w-2xl flex-col overflow-hidden rounded-2xl border border-gray-100 p-0 shadow-2xl sm:max-h-[calc(100vh-4rem)]"
    >
      {stepId && (
        <SectionStep
          stepId={stepId}
          data={saved?.attributes ?? data}
          completed={completed || Boolean(saved)}
          practice={practice}
          onSaved={setSaved}
          onClose={onClose}
        />
      )}
    </Modal>
  );
};

export default ProfileModal;
